<template>
    <div></div>
</template>

<script>
import { Toast} from 'vant';
    export default{
        data(){
            return{

            }
        },
       created(){
           Toast.loading({
            message: '授权中...',
            forbidClick: true,
            duration:0
            });
           	if(this.$route.query.token){
				localStorage.setItem('token',this.$route.query.token);
                let url=window.localStorage.getItem('callback_url')
                window.location.href=url;
			}
       }
    }
</script>



// WEBPACK FOOTER //
// src/pages/Wechatauth.vue